import { config } from '@/config.ts';

type BrandNameConfig = Record<string, string>;

/**
 * Map of display names for each brand
 * Used in promotional texts, titles, etc.
 */
export const brandNameMap: BrandNameConfig = {
	default: 'Parimatch',
	nomad: 'Nomad',
	ngu3: 'Johnny24',
	com2: 'Viphouse',
	blitz: 'King Casino',
	rockets: 'Parimatch',
	rockets_vip: 'Parimatch',
	sk2: 'Parimatch'
};

/**
 * Map of shop names for each brand
 * Used in texts like "магазині PM Pass" / "магазині X-Pass"
 */
export const brandShopNameMap: BrandNameConfig = {
	default: 'PM Pass',
	nomad: 'Nomad',
	ngu3: 'X-Pass',
	com2: 'Vip House',
	blitz: 'King Casino',
	rockets: 'Parik24',
	rockets_vip: 'Parik24',
	sk2: 'SK2'
};

/**
 * Get display name for the current brand
 * @returns string - Display name for current brand
 */
export const getBrandName = (): string => {
	const brand = config.BRAND || 'default';
	return brandNameMap[brand] || brandNameMap.default;
};

/**
 * Get shop name for the current brand
 * @returns string - Shop name for current brand
 */
export const getBrandShopName = (): string => {
	const brand = config.BRAND || 'default';
	return brandShopNameMap[brand] || brandShopNameMap.default;
};

